import styled, { keyframes } from 'styled-components';
import { viewports } from 'app/shared/styles/_breakpoints';
import { colors } from 'app/shared/styles/_colors';
import Text from 'app/shared/core/Text';
import { font } from 'app/shared/styles/_fontsize';

export const Container = styled.section`
  box-shadow: 0 2px 6px ${colors['$hpx-grey-400']};
  padding: 15px;
  margin: 0 auto;
  width: 100%;
  border-radius: 10px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 10px;

  @media ${viewports['md-and-up']} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 0 10px 12px;
  }
`;

export const HeaderText = styled.h2`
  font-weight: bold;
  ${font.lg}
`;

export const ListingsContainer = styled.ul`
  display: flex;
  flex-wrap: wrap;

  gap: 8px;
  justify-content: space-around;
  margin: 20px 0px;

  @media ${viewports['md-only']} {
    align-items: center;
  }

  @media ${viewports['md-and-up']} {
    gap: 24px;
  }

  @media (min-width: 892px) {
    justify-content: flex-start;
  }
`;

export const LoadingListingContainer = styled.div`
  @media ${viewports['md-and-up']} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 15px;
    margin: 0 8px;
  }
`;

export const ctaText = styled(Text)`
  display: flex;
  justify-content: center;
  margin-top: 5px;
`;

const breatheAnimation = keyframes`
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.6;
    }
    100% {
        opacity: 1;
    }
`;

export const ctaSkeleton = styled.div`
  background-color: ${colors['$hpx-grey-400']};
  width: 90%;
  height: 19.2px;
  margin: 5px auto 0;
  animation: ${breatheAnimation} 1.5s infinite;

  @media ${viewports['md-and-up']} {
    width: 40%;
  }
`;

export const NoListingMessage = styled(Text)`
  display: flex;
  justify-content: center;
  margin: 10px 0;
  text-align: center;

  @media ${viewports['md-and-up']} {
    margin: 10px;
  }
`;

export const ErrorContainer = styled.div`
  display: flex;
  gap: 10px;
  margin: 10px 0;
  align-items: center;
  justify-content: center;
`;

export const ErrorIcon = styled.img`
  width: 20px;
  height: 20px;
`;

export const ErrorMessage = styled(Text)`
  font-weight: bold;
  color: ${colors['$hpx-red-400']};
`;
